import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';

@Component({
    selector: 'app-fa-logo',
    templateUrl: './fa-logo.component.html',
    styleUrls: ['./fa-logo.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class FaLogoComponent implements OnInit {
    @Input() logoStyle: 'long' | 'stacked' | 'logo' = 'stacked';
    @Input() theme: 'light' | 'dark' = 'light';
    @Input() showAdventureTrips: boolean = false;

    constructor() {}

    ngOnInit(): void {}
}
